import React from 'react';
import { Container, Row, Col, Card, Tab, Nav } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from '../common/FalconCardHeader';
import ExecutiveDashboard from '../performance/ExecutiveDashboard';

const ReportsPage = () => {
  return (
    <Container fluid className="px-3">
      <div className="pb-4">
        {/* Header */}
        <div className="mb-4">
          <Row className="align-items-center">
            <Col>
              <h2 className="mb-2">
                <FontAwesomeIcon icon="chart-bar" className="me-2 text-primary" />
                Reportes y Analytics
              </h2>
              <h5 className="text-700 fw-semi-bold">
                Visualiza métricas y genera reportes detallados
              </h5>
            </Col>
          </Row>
        </div>

        <Card className="shadow-sm">
          <FalconCardHeader title="Reportes" />
          <Card.Body>
            <Tab.Container defaultActiveKey="dashboard">
              <Nav variant="tabs" className="justify-content-center mb-3">
                <Nav.Item>
                  <Nav.Link eventKey="dashboard">
                    <FontAwesomeIcon icon="tachometer-alt" className="me-1" />
                    Dashboard Ejecutivo
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="financial">
                    <FontAwesomeIcon icon="dollar-sign" className="me-1" />
                    Reportes Financieros
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="export">
                    <FontAwesomeIcon icon="download" className="me-1" />
                    Exportar Datos
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="dashboard">
                  <ExecutiveDashboard />
                </Tab.Pane>
                <Tab.Pane eventKey="financial">
                  <div className="text-center py-5">
                    <FontAwesomeIcon icon="dollar-sign" size="3x" className="text-muted mb-3" />
                    <h6>Reportes Financieros</h6>
                    <p className="text-muted">Análisis financiero detallado</p>
                    <p className="text-muted">Este módulo está en desarrollo.</p>
                  </div>
                </Tab.Pane>
                <Tab.Pane eventKey="export">
                  <div className="text-center py-5">
                    <FontAwesomeIcon icon="download" size="3x" className="text-muted mb-3" />
                    <h6>Exportar Datos</h6>
                    <p className="text-muted">Exporta datos en diferentes formatos</p>
                    <p className="text-muted">Este módulo está en desarrollo.</p>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Card.Body>
        </Card>
      </div>
    </Container>
  );
};

export default ReportsPage; 